<script lang="ts" setup>
import type { FiltersFormModel } from '../../../runtime/services/FilterService';
import FilterService from '../../../runtime/services/FilterService';

const show = defineModel<boolean>();
const props = defineProps<{
    canManage: boolean;
}>();
const emit = defineEmits<{
    (e: 'save'): void;
}>();

const { $alert } = useAlerts();
const { $t } = useLocalization();

const filter = inject<FormType<any>>('filter');
const visible = inject<Ref<string[]>>('visible');
const dirty = inject<Ref<string[]>>('dirty');
const apply = inject<() => void>('apply');

const currentFilter = computed(() => getFilterState());

const form = ref(Form.create<FiltersFormModel>({
    id: 0,
    name: '',
    filterType: 'Private',
    contentJson: '{}',
    viewId: ''
}));

watch(show, (value) =>
{
    if (value == true)
    {
        form.value.withData(currentFilter.value.activeTemplate);
    }
});

function cancelEdit()
{
    show.value = false;
    form.value.reset();
}

async function saveFilter()
{
    try
    {
        form.value.contentJson = JSON.stringify({
            visible: visible.value,
            form: filter.data()
        });

        await FilterService.update(form.value.id, form.value);

        setFilterState({
            activeTemplate: form.value.data(),
            visible: visible.value,
            form: filter
        });
        apply();

        $alert.success($t('[[[Filtr został zapisany]]]'));

        dirty.value.clear();
        cancelEdit();
        emit('save');
    }
    catch
    {
        $alert.danger($t('[[[Nie udało się zapisać filtra]]]'));
    }
}
</script>

<template>
    <IdeoModal v-model="show" :title="$t('[[[Zapisz filtr]]]')">
        <IdeoFormGroup :label="$t('[[[Nazwa filtra]]]')" required>
            <IdeoFormInput v-model="form.name" v-focus type="text" name="name" />
        </IdeoFormGroup>
        <IdeoFormRadioGroup v-if="props.canManage">
            <IdeoFormRadio v-model="form.filterType" name="filter-mode" value="Private">
                {{ $t('[[[Filtr prywatny]]]') }}
            </IdeoFormRadio>
            <IdeoFormRadio v-model="form.filterType" name="filter-mode" value="Global">
                {{ $t('[[[Filtr domyślny]]]') }}
            </IdeoFormRadio>
        </IdeoFormRadioGroup>
        <template #modal-footer>
            <div class="d-flex justify-content-end">
                <IdeoButton variant="light" @click="cancelEdit()">
                    {{ $t('[[[Anuluj]]]') }}
                </IdeoButton>
                <IdeoButton variant="primary" @click="saveFilter()">
                    {{ $t('[[[Zapisz]]]') }}
                </IdeoButton>
            </div>
        </template>
    </IdeoModal>
</template>
